/* EHP behaviour: scroll reveals, number counters, countdown, mobile nav, tabs. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- reveal on scroll --------------------------------------------------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.ehp-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('ehp-in'); });
      return;
    }
    function reveal(el) {
      var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
      setTimeout(function () { el.classList.add('ehp-in'); countUp(el); }, delay);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        reveal(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    /* The observer wants 12% of an element inside a root shortened by 12%,
       which a tall section under a tall hero can sit in plain view without
       ever reaching - the blog's lead article shows 138px of itself on load
       and still counts as only 6%. So anything already on screen is revealed
       on its own and only what is below the fold is left to the observer.
       The two frames let the opacity-0 starting state paint first, so these
       still animate in rather than snapping. */
    Array.prototype.forEach.call(els, function (el) {
      var box = el.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { reveal(el); });
        });
        return;
      }
      io.observe(el);
    });
  }

  /* --- number counters ---------------------------------------------------- */
  function countUp(scope) {
    var nums = scope.querySelectorAll('[data-counter]:not([data-counted])');
    Array.prototype.forEach.call(nums, function (n) {
      n.setAttribute('data-counted', '1');
      var target = parseFloat(n.getAttribute('data-counter'));
      if (isNaN(target)) return;
      if (reduce) { n.textContent = target; return; }
      var dur = 1400, t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        n.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      n.textContent = '0';
      requestAnimationFrame(step);
    });
  }

  /* --- countdown ---------------------------------------------------------- */
  function initCountdown() {
    var boxes = document.querySelectorAll('[data-countdown]');
    if (!boxes.length) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = Date.now();
      Array.prototype.forEach.call(boxes, function (box) {
        var target = Date.parse(box.getAttribute('data-countdown'));
        if (isNaN(target)) return;
        var d = Math.max(0, target - now), s = Math.floor(d / 1000);
        var parts = {
          days: Math.floor(s / 86400),
          hours: Math.floor((s % 86400) / 3600),
          mins: Math.floor((s % 3600) / 60),
          secs: s % 60
        };
        Object.keys(parts).forEach(function (k) {
          var el = box.querySelector('[data-cd="' + k + '"]');
          if (el) el.textContent = pad(parts[k]);
        });
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* --- mobile nav --------------------------------------------------------- */
  function initNav() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ehp-nav-toggle]');
      if (!btn) return;
      var links = document.querySelector('.ehp-header__nav');
      if (!links) return;
      var open = links.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* --- tabs (program directory) ------------------------------------------- */
  /* The panels are all rendered and the first is left visible, so the section
     reads correctly before this runs. Here we only move `hidden`,
     aria-selected and roving tabindex between them. */
  function initTabs(root) {
    var frames = (root || document).querySelectorAll('[data-ehp-tabs]:not([data-ehp-tabs-ready])');
    Array.prototype.forEach.call(frames, function (frame) {
      var tabs = frame.querySelectorAll('[role="tab"]');
      if (!tabs.length) return;
      frame.setAttribute('data-ehp-tabs-ready', '1');

      function select(index, focus) {
        Array.prototype.forEach.call(tabs, function (tab, i) {
          var on = i === index;
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
          tab.classList.toggle('is-active', on);
          if (panel) panel.hidden = !on;
        });
        if (focus) tabs[index].focus();
      }

      Array.prototype.forEach.call(tabs, function (tab, i) {
        tab.addEventListener('click', function () { select(i, false); });
        tab.addEventListener('keydown', function (e) {
          var last = tabs.length - 1, next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i === last ? 0 : i + 1;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i === 0 ? last : i - 1;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = last;
          if (next === null) return;
          e.preventDefault();
          select(next, true);
        });
      });
    });
  }

  /* --- overlaid header: publish its height so sections can offset ---------- */
  function measureHeader() {
    var h = document.querySelector('.ehp-header--overlay');
    document.documentElement.style.setProperty(
      '--ehp-header-h', h ? Math.round(h.getBoundingClientRect().height) + 'px' : '0px');
  }

  function boot() { measureHeader(); initReveal(document); initCountdown(); initNav(); initTabs(document); }

  window.addEventListener('resize', measureHeader);
  window.addEventListener('load', measureHeader);

  /* Theme editor: a newly added block should animate in immediately. */
  document.addEventListener('shopify:block:select', function (e) {
    var host = e.target.closest('[data-reveal]') || e.target;
    if (host && host.classList) { host.classList.add('ehp-in'); countUp(host); }
    /* Selecting a discipline in the editor should show that discipline,
       not leave the merchant editing a panel they cannot see. */
    var tab = e.target.closest && e.target.closest('[role="tab"]');
    if (tab) tab.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  /* Shopify theme editor: re-init when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target); initCountdown(); initTabs(e.target);
  });
})();
